import { render, staticRenderFns } from "./tempImportRoomFee.vue?vue&type=template&id=2f272a5c&scoped=true"
import script from "./tempImportRoomFee.vue?vue&type=script&lang=js"
export * from "./tempImportRoomFee.vue?vue&type=script&lang=js"
import style0 from "./tempImportRoomFee.vue?vue&type=style&index=0&id=2f272a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f272a5c",
  null
  
)

export default component.exports